import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Token - 生成一次性驗證Token
 */
const GenerateToken = [
    'POST',
    RouteUrlList.API_GenerateToken.path,
    {},
    200,
    {
        status: true,
        code: 0,
        exception: null,
        message: '成功生成驗證Token',
        result: {
            token: 'a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6a7b8c9d0e1f2g3h4i5j6k7l8m9n0',
            tokenHash: '8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918',
            expiry: '2025-01-13T14:30:00+08:00',
            mobileVerifyUrl:
                'https://mobile.example.com/verify?token=a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6a7b8c9d0e1f2g3h4i5j6k7l8m9n0',
            qrCodeBase64: 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=='
        }
    }
];

export default GenerateToken;
